import ModalLayout from "../../layouts/ModalLayout";
import OrdersDeleteModal from "../../modals/OrdersDeleteModal";
import {useCurrentOrders} from "../../hooks/useOrdersHook";
import TableLayout from "../../layouts/TableLayout";
import {currentOrderAttributes} from "../../constants/headers";
import {Column, Row, TradeTypeBadge} from "../../styles/table";
import CoinMarket from "../common/utils/CoinMarket";
import {formatDate, formatNumber} from "../../utils/common";
import {BuyIcon, DeleteIcon, SellIcon, TextWithMargin} from "../../styles/OrdersStyle";
import Text from "../../utils/Text";
import {Flex} from "../../styles/MarketStyles";
import {getTradeTypeColor} from "../../utils/theme";
import {useMainContext} from "../../contexts/main";


const CurrentOrders = ({ data }) => {

    const { main: {lang} } = useMainContext()

    const {
        deleteModal,
        setDeleteModal,
        onCloseDeleteModal,
        onModalClicked
    } = useCurrentOrders()

  const { data: orders } = data
  const { cs, headers } = currentOrderAttributes

  return (
    <>
      <TableLayout
        data={data}
        cs={cs}
        headers={headers}
      >
          {orders?.data?.map((item, idx) => {

              let percent = 0
              if (item.tradedAmount) {
                  percent = (item.tradedAmount / (item.amount + item.tradedAmount)) * 100
              }

              return (
                  <Row
                      index={idx}
                      cs={cs}
                      percent={percent}
                      type={item.type}
                      currentOrder
                  >
                      <Column>
                          {idx + 1}
                      </Column>
                      <Column>
                          <CoinMarket
                              coin={item.coin}
                              pair={item.pair}
                          />
                      </Column>
                      <Column>
                          {formatNumber(item.amount + item.tradedAmount)}
                      </Column>
                      <Column>
                          {formatNumber(item.priceUnit)}
                      </Column>
                      <Column>
                          {formatNumber(item.price)}
                      </Column>
                      <Column>
                          <Flex>
                              {item.type === "buy" ?
                                  <BuyIcon />
                                  :
                                  <SellIcon />
                              }
                              <TextWithMargin type={item.type}>
                                  <Text tid={item.type} />
                              </TextWithMargin>
                          </Flex>
                      </Column>
                      <Column>
                          <TradeTypeBadge color={getTradeTypeColor(item.submit)}>
                              {item.submit}
                          </TradeTypeBadge>
                      </Column>
                      <Column>
                          {`% ${percent.toFixed(2)}`}
                      </Column>
                      <Column>
                          {`${formatDate(item.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                        -${formatDate(item.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}`}
                      </Column>
                      <Column onClick={() => setDeleteModal({ id: item._id, open: true })}>
                          <DeleteIcon size={14}/>
                      </Column>
                  </Row>
              )
          })}
      </TableLayout>
      <ModalLayout
        width="400px"
        open={deleteModal.open}
        onClose={onCloseDeleteModal}
      >
        <OrdersDeleteModal onModalBtnClicked={onModalClicked} />
      </ModalLayout>
    </>
  );
};


export default CurrentOrders;
